import { NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}

@Injectable()
export class CustomNgxDateAdapter extends NgxMatNativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      return _parse(value, false);
    }
    return super.parse(value);
  }
}

@Injectable()
export class AppDateTimeAdapter extends NgxMatNativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      return _parse(value, true);
    }
    return super.parse(value);
  }
}

function _parse(value: string, includeHours: boolean): Date | null {
  value = value.trim();
  const _value = value.includes(',') ? value.split(',') : _splitOnFirstSpace(value);
  if (_value.length > 2) return null;
  const [date, time] = _value;
  const [day, month, year] = date.split('.');
  const [hours, minutes, seconds] = time && includeHours ? time.split(':') : ['00', '00', '00'];
  return _isValidDate(year, month, day, hours, minutes, seconds)
    ? new Date(..._parseDate(year, month, day, hours, minutes, seconds))
    : null;
}

function _isValidDate(year: string, month: string, day: string, hours: string, minutes: string, seconds: string): boolean {
  if (!year || !month || !day) return false;
  const [y, m, d, h, mi, s] = _parseDate(year, month, day, hours, minutes, seconds);
  for (const e of [y, m, d, h, mi, s]) {
    if (isNaN(e)) return false;
  }
  if (y < 0 || m < 0 || d < 1) return false;
  if (h < 0 || mi < 0) return false;
  return true;
}

function _parseDate(
  y: string,
  m: string,
  d: string,
  h: string,
  mi: string,
  s = '0'
): [number, number, number, number, number, number] {
  return [
    _completeYear(parseInt(y, 10)),
    parseInt(m, 10) - 1,
    parseInt(d, 10),
    parseInt(h, 10),
    parseInt(mi, 10),
    parseInt(s, 10)
  ];
}

function _completeYear(y: number): number {
  if (y < 100) return y + (new Date().getFullYear() - y >= 2000 ? 2000 : 1900);
  return y;
}

function _splitOnFirstSpace(value: string): [string, string] {
  const i = value.indexOf(' ');
  return i === -1 ? [value, '00:00:00'] : [value.slice(0, i), value.slice(i + 1, value.length)];
}
